import type { BlocksContent } from "vue-strapi-blocks-renderer";
import { getLongLocaleCode } from "@/i18n";
import type { RMDFaqResponse } from "@/services/types/RMDFaqResponse";

export interface RMDFaqSection {
    title: string;
    contents: BlocksContent[];
}

export interface RMDFaqTab {
    id: string;
    title: string;
    sections: RMDFaqSection[];
}

export class RMDFaqStore {
    cache: RMDFaqResponse[] = [];

    getForLocale(shortLocale: string): RMDFaqResponse[] {
        return this.cache.filter(faq => faq.locale === getLongLocaleCode(shortLocale));
    }

    hasFaqs(shortLocale: string): boolean {
        return this.getForLocale(shortLocale).length > 0;
    }

    getTabs(shortLocale: string): RMDFaqTab[] {
        const tabs = new Map<string, RMDFaqTab>();

        this.getForLocale(shortLocale).forEach(faq => {
            let tab = tabs.get(faq.tabName);
            if (!tab) {
                tab = { id: faq.tabName, title: faq.tabName, sections: [] };
                tabs.set(faq.tabName, tab);
            }

            let section = tab.sections.find(section => section.title === faq.sectionName);
            if (!section) {
                section = { title: faq.sectionName, contents: [] };
                tab.sections.push(section);
            }
            section.contents.push(faq.content);
        });

        return Array.from(tabs.values());
    }
}
